// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {
		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 *****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		
		// Main Nav Dropdown
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		let allwrapItems = document.querySelectorAll('.js-info-item');
		if (allwrapItems.length === 0) {
			console.log("there's not element .js-info-item");
			return;
		}
		allwrapItems.forEach(item => {
			item.addEventListener('click', () => {
				if (item.classList.contains('active')) {
					item.classList.remove('active');
				} else {
					allwrapItems.forEach(item => item.classList.remove('active'));
					item.classList.add('active');
				}
			});
		});

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});

		/* Gallerys Mobile delay style */
		if (window.innerWidth < 768) {
			setTimeout(() => {
				if (document.querySelector('#gallery-flex #start-content')) {
					document.querySelector('#gallery-flex #start-content').classList.add('loading');
				}
			}, 800);
			
		}
		

		// Attractions columns ----------------------------------------------------------
	

			let link_filter = document.querySelectorAll(".js-filter");
			let all_item = document.querySelectorAll(".js-column");
			let select_filter = document.getElementById("select_room");

			// Desktop Filter

			if (link_filter) {
				link_filter.forEach(link => {
					link.addEventListener('click', function(e) {
						e.preventDefault();

						link_filter.forEach(item => item.classList.remove("active"));
						this.classList.add("active");

						const filter_tag = this.dataset.filter;

						all_item.forEach(currentItem => {
							currentItem.classList.toggle("hidden", !currentItem.classList.contains(filter_tag));
						});
					});
				});
			}
			
			// Mobile Filter

			function filterItems(filter_tag) {
				all_item.forEach(currentItem => {
				currentItem.classList.toggle("hidden", !currentItem.classList.contains(filter_tag));
				});
			}
		
			if (link_filter) {
				link_filter.forEach(link => {
					link.addEventListener('click', function(e) {
					e.preventDefault();
			
					link_filter.forEach(item => item.classList.remove("active"));
					this.classList.add("active");
			
					const filter_tag = this.dataset.filter;
			
					filterItems(filter_tag);
					});
				});
			}
		
			if (select_filter) {
				select_filter.addEventListener('change', function() {
					const filter_tag = this.options[this.selectedIndex].dataset.filter;
					filterItems(filter_tag);
			});
		}

		// Remove BR label from amenities title on mobile devices
		let amenitiesTitle = document.querySelectorAll('.js-remove-br');
		if(amenitiesTitle){
				if (window.innerWidth < 640) {
						amenitiesTitle.forEach(element => {
						element.innerHTML = element.innerHTML.replace(/<br\s*\/?>/gi, '');
					});
				}
			}
		});

		

		window.onload = function() {
			if(document.getElementById('header').classList.contains('with-hero')){
				scrollW();
				window.addEventListener('scroll', function(){
					scrollW();
				})
			} else{
				document.getElementById('header').classList.add('scroll');
				let logoUrl = '/assets/svg/logo.svg';
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				
			}
		};
		/* Remove empty <p> tags created by tinymce */
		const paragraph = document.querySelectorAll('p') || [];
		paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

		//// Forms animation for labels   ----------------------------------------------------------------
		//Email signup animation
		if (document.getElementById('email-signup_email_address')) {
			document.getElementById('email-signup_email_address').addEventListener('focus', function () {
				this.parentElement.classList.add('moved');
			});
		}
		if (document.getElementById('email-signup_first_name')) {
			document.getElementById('email-signup_first_name').addEventListener('focus', function () {
				this.parentElement.classList.add('moved');
			});
		}
		if (document.getElementById('email-signup_last_name')) {
			document.getElementById('email-signup_last_name').addEventListener('focus', function () {
				this.parentElement.classList.add('moved');
			});
		}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

		// BURGER MENU NAVIGATION:

			// BURGUER MENU DESKTOP ----------------------------------------------------------------

			const menuBtn = document.getElementById('menu-btn');
			const navigation = document.querySelector('.navigation');
			const closeMenuBtn = document.querySelector('.js-close-menu');

			menuBtn.addEventListener('click', function(event) {
				event.preventDefault();
				navigation.classList.add('open');
			});

			closeMenuBtn.addEventListener('click', function(event) {
				event.preventDefault();
				navigation.classList.remove('open');
			});

		// BURGUER MENU MOBILE ----------------------------------------------------------------

		const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
		const burgerMenuContainer = document.querySelector("#js-menuContainer")
		const closeMenu = document.querySelector(".js-burger-close");
		
		//Open Menu

		if(burgerMenuBtn){
			burgerMenuBtn.addEventListener('click', function (e) {
				e.preventDefault();
				burgerMenuContainer.classList.add("open");
				document.body.classList.add("no-scroll");
			});
		}
		
		if(closeMenu){
			closeMenu.addEventListener('click', () => {
				burgerMenuContainer.classList.remove("open");
				document.body.classList.remove("no-scroll");
			});
		}

		// SHOW SUBMENU FUNCTION: 

		const submenuToShow = (linksSelector, linkSubmenu) => {
			let navLinks = document.querySelectorAll(linksSelector); 
			let submenu_active = document.querySelectorAll(linkSubmenu); 

			navLinks.forEach(link => {
				const parent = link.parentNode;
				let submenu = parent.querySelector('.submenu');
				link.addEventListener('click', (e) => {
					document.querySelectorAll('.submenu.active').forEach(activeSubmenu => {
						activeSubmenu.classList.remove('active');
					});
					document.querySelectorAll(`${linksSelector}.active`).forEach(activeLink => {
						activeLink.classList.remove('active');
					});
					link.classList.toggle('active');
					submenu.classList.toggle('active');
				});
			});
			submenu_active.forEach(sub => {
				if (sub.classList.contains('active')) {
					if (window.screen.width > 640) {
						let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}else{
						let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}
				}

			})
		}

		if (window.screen.width > 640) {
			submenuToShow('#primary-nav li a', '.submenu li a');
		} else {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}


		// Remove br inside ADA STATEMENT 
		const adaStatementWrapper = document.querySelector('.ada-statement.text-modules-wrapper');

		if (adaStatementWrapper) {
		const paragraphs = adaStatementWrapper.querySelectorAll('p');

		if (paragraphs.length > 0) {
				const lastParagraph = paragraphs[paragraphs.length - 1];

				const firstBr = lastParagraph.querySelector('br');

				if (firstBr) {
					firstBr.remove();
				}
			}
		}

		//ADA LABELS
		document.querySelector(".footer #email-signup .signup-btn").setAttribute("aria-label", "Sign up to our email database");
		if(document.querySelector("#form_id-3608 .form-module__submit .btn")){
			document.querySelector("#form_id-3608 .form-module__submit .btn").setAttribute("aria-label", "Submit contact information");
		}

		// PRIMARY NAV NUMBERS ****************************************************************

		if (window.screen.width > 640) {

			
			const liElements = document.querySelectorAll('#privary-navigation li');
			let navCounter = 1;
			
			liElements.forEach(function(li) {
				if (!li.parentElement.classList.contains('privary-navigation__submenu')) {
					let textNode = document.createElement('span');
					textNode.innerHTML = '<span class="number">0' + navCounter + '</span>';
					li.querySelector('a').insertBefore(textNode, li.querySelector('a').firstChild);
					navCounter++;
				}
			});
		
		}else{
			const liElements = document.querySelectorAll('.mobileMenu__nav li');
			let navCounter = 1;

			liElements.forEach(function(li) {
				if (!li.parentElement.classList.contains('submenu')) {
					let textNode = document.createElement('span');
					textNode.innerHTML = '<span class="number">0' + navCounter + '</span>';
					li.querySelector('a').insertBefore(textNode, li.querySelector('a').firstChild);
					navCounter++;
				}
			});
		}

	
		
		const navItems = document.querySelectorAll('.privary-navigation__item');
		const navItemsMob = document.querySelectorAll('.mobileMenu__nav li');

		
		
		function addNoSubmenuClass() {
			navItems.forEach(item => {
				
				const submenu = item.querySelector('.privary-navigation__submenu');

				
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});
		}
		
		function addNoSubmenuMobileClass() {
		navItemsMob.forEach(item => {
			
			const submenu = item.querySelector('.sub-sub-menu');

			
			if (!submenu) {
				item.classList.add('no-submenu');
			}
		});

	}
	if(window.screen.width > 768) {
		addNoSubmenuClass();

	}else{
		addNoSubmenuMobileClass()
	}


	// Home Day Night Filter ********************************

	document.addEventListener('DOMContentLoaded', function () {
    const filterItems = document.querySelectorAll(".filter-item");
    const imageItems = document.querySelectorAll(".js-item");
	
	if(filterItems.length > 0){
		filterItems[0].classList.add('active');
	}
    function handleHover() {
        const smallImages = document.querySelectorAll('.small-image:not(.hidden)');
        smallImages.forEach(function (smallImage) {
            smallImage.addEventListener('mouseover', function () {
                const dataName = this.getAttribute('data-name');
                const dataTag = this.getAttribute('data-tag');

                const matchingBigImage = document.querySelector(`.big-image[data-name="${dataName}"][data-tag="${dataTag}"]`);
                if (matchingBigImage) {
                    matchingBigImage.classList.add('active');
                }
            });

            smallImage.addEventListener('mouseout', function () {
                const dataName = this.getAttribute('data-name');
                const dataTag = this.getAttribute('data-tag');

                const matchingBigImage = document.querySelector(`.big-image[data-name="${dataName}"][data-tag="${dataTag}"]`);
                if (matchingBigImage) {
                    matchingBigImage.classList.remove('active');
                }
            });
        });
    }

	const seoHeadlines = document.querySelectorAll('.block .seoheadline');
    const jsItems = document.querySelectorAll('.js-item[data-name]');

    function toggleSeoHeadlineHover(dataName) {
        seoHeadlines.forEach((headline) => {
            headline.classList.remove('hover');
        });

        // Add hover class to the matching seoHeadline
        const matchingHeadline = document.querySelector(`.block .seoheadline[data-name="${dataName}"]`);
        if (matchingHeadline) {
            matchingHeadline.classList.add('hover');
        }
    }

    // Loop through jsItems to add hover event listeners
    jsItems.forEach((jsItem) => {
        jsItem.addEventListener('mouseover', () => {
            const dataName = jsItem.getAttribute('data-name');
            toggleSeoHeadlineHover(dataName);
        });

        jsItem.addEventListener('mouseout', () => {
            seoHeadlines.forEach((headline) => {
                headline.classList.remove('hover');
            });
        });
    });

    handleHover();

	// Slider day night ****************************

	const sliderDay = document.querySelector('.js-day-slider'); 
	const sliderNight = document.querySelector('.js-night-slider'); 
	function toggleSliders(selectedTag) {
		if (selectedTag === 'night') {
			sliderDay.classList.add('hidden');
			sliderNight.classList.remove('hidden'); 
		} else {
			sliderDay.classList.remove('hidden');
			sliderNight.classList.add('hidden'); 
		}
	}

    filterItems.forEach(item => {
        item.addEventListener("click", function () {
			
            const selectedTag = this.getAttribute("data-tag");			 
			filterItems.forEach(item => item.classList.remove('active'));
			item.classList.add('active');

            imageItems.forEach(img => {
                img.classList.add("hidden");
            });

            imageItems.forEach(img => {
                if (img.getAttribute("data-tag") === selectedTag) {
                    img.classList.remove("hidden");
                }
            });
			
			if(sliderDay && sliderNight ){
				toggleSliders(selectedTag);
			} else{
				handleHover();

			}
        });
    });
	
	// location accordion ************************************************

	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('open');
				});
				itemHead.parentNode.classList.toggle('open');
			});
		});
	});
	
	const accordionTitles = document.querySelectorAll('.js-accordion-title');
	const pins = document.querySelectorAll('.js-pins figure');

	accordionTitles.forEach(title => {
		title.addEventListener('click', () => {
			const isOpen = title.classList.contains('open');
			accordionTitles.forEach(el => el.classList.remove('open'));

			if (!isOpen) {
				title.classList.add('open');
			}

			pins.forEach(pin => pin.classList.remove('active'));

			if (title.classList.contains('open')) {
				const tag = title.getAttribute('data-tag');
				pins.forEach(pin => {
					if (pin.getAttribute('data-tag') === tag) {
						pin.classList.add('active');
					}
				});
			}
		});
	});


	// Submenu mobile turn into Select ************************************
	
	function isMobile() {
		return window.innerWidth <= 640;
	}
	
	function convertSubmenuToSelect() {
		const submenu = document.querySelector('.sub-menu__hold .sub-menu ul');
		if (!submenu) return;
	
		const select = document.createElement('select');
		select.setAttribute('aria-label', 'Section Navigation');
	
		submenu.querySelectorAll('li').forEach((li) => {
		const link = li.querySelector('a');
		const option = document.createElement('option');
		option.value = link.href;
		option.textContent = link.textContent.trim();
	
		if (link.classList.contains('active')) {
			option.selected = true;
		}
		
		select.appendChild(option);
		});
	
		select.addEventListener('change', (event) => {
		const selectedUrl = event.target.value;
		if (selectedUrl) {
			window.location.href = selectedUrl;
		}
		});
	
		submenu.parentNode.replaceChild(select, submenu);
	}
	
	if (isMobile()) {
		convertSubmenuToSelect();
	}

	const introContent = document.querySelector('#intro-content');
    if(introContent){
		if (introContent && introContent.querySelector('.sub-menu__hold .sub-menu')) {
			introContent.classList.add('with-submenu');
		} else {
			introContent.classList.remove('with-submenu'); 
		}
	}

	// Update href in sitemap ********************************************
	
	function updateHrefSitemap(selector, searchText) {
		const links = document.querySelectorAll(`${selector} li > a`);
		links.forEach(link => {
			if (link.textContent.trim() === searchText) {
				link.setAttribute("href", "javascript:void(0)");
			}
		});
	}
	updateHrefSitemap(".global-sitemap", "Experience");
	updateHrefSitemap(".global-sitemap", "Gather");
	
		
		// Scroll negative subnav link ******************************************

		if(document.querySelector('.sub-menu__hold ul li .js-filter-btn')) {
			const navButtons = document.querySelector('.sub-menu__hold ul li .js-filter-btn');
			navButtons.addEventListener('click', () => {
				console.log('test');
				setTimeout(() => {
					const hash = window.location.hash.substring(1); 
					if (!hash) return; 
	
					const matchingTag = document.querySelector(`.taste-list__filter [data-filter="${hash}"]`);
					const dropdown = document.querySelector('#select_list');
	
					if (matchingTag) {
						matchingTag.click();
						animateTo(document.querySelector('#taste-list-container'), 260);
			
					} else if (dropdown) {
						dropdown.value = hash;
						animateTo(document.querySelector('#taste-list-container'), 260);
					}
				}, 1000);
			});
		}

		setTimeout(() => {
			const hash = window.location.hash.substring(1); // Obtener el hash de la URL
			if (!hash) return; // Salir si no hay hash en la URL
		
			// Buscar el elemento con data-filter que coincida con el hash
			const matchingTag = document.querySelector(`.taste-list__filter [data-filter="${hash}"]`);
			const dropdown = document.querySelector('#select_list');
		
			// Verificar y ejecutar acciones si el hash coincide con data-filter
			if (matchingTag) {
				matchingTag.click();
				animateTo(document.querySelector('#taste-list-container'), 260);
			} else if (dropdown && dropdown.querySelector(`option[value="${hash}"]`)) {
				// Verificar si el hash coincide con un valor en el dropdown
				dropdown.value = hash;
				animateTo(document.querySelector('#taste-list-container'), 260);
			}
		}, 400);
	});

	// OneTrust cookies setting button
	if(document.querySelector('nav#third-footer .tertiary-navigation__list')) {
		let listElements = document.querySelectorAll('nav#third-footer .tertiary-navigation__list li');
		let lastItem = listElements[listElements.length - 1];
		lastItem.innerHTML = `<a class="ot-sdk-show-settings" nohref="nohref" style="cursor:pointer;">Cookie Preferences</a>`
	}
	//
})();

function animateTo(targetElement, offset = 140) {
    var gotoTarget = targetElement.getBoundingClientRect().top + window.pageYOffset - offset; 
    var from = window.pageYOffset;
    var to = gotoTarget;
    var duration = 1300;
    var start = new Date().getTime();

    var timer = setInterval(function () {
        var time = new Date().getTime() - start;

        var y = easeInOutQuart(time, from, to - from, duration);
        window.scrollTo(0, y);

        if (time >= duration) clearInterval(timer);

    }, 1000 / 60); 

    window.scrollTo(0, from); 
}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop

	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	let SubMenu = document.getElementById('subMenuAnchor');
	if(SubMenu){
		let subPost = document.getElementById('subMenu');
		let subPosition = '';
		if(document.body.classList.contains('alert_open')){
			subPosition = offset(SubMenu).top - 120;
		} else {
			subPosition = offset(SubMenu).top - 80;
		}
		if(st > subPosition){
			if(!subPost.classList.contains('floating-up')){
				subPost.classList.add('floating-up');
			}
		} else {
			if(subPost.classList.contains('floating-up')) {
				subPost.classList.remove('floating-up');
			}
		}
	}

	
}

function toggleFixedSubmenuOnScroll() {
	const header = document.getElementById('header');
	const subMenuHold = document.querySelector('.sub-menu__hold');

	if (!header || !subMenuHold) return; 
	const initialSubMenuHoldTop = subMenuHold.getBoundingClientRect().top + window.scrollY;

	window.addEventListener('scroll', () => {
		const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
		if (headerBottom >= initialSubMenuHoldTop) {
		subMenuHold.style.position = 'fixed';
		subMenuHold.style.top = '100px';
		} else if (window.scrollY < initialSubMenuHoldTop) {
		subMenuHold.style.position = 'absolute';
		subMenuHold.style.top = '0px';
		}
	});
}

toggleFixedSubmenuOnScroll();

const countDown = function (elements) {

	for (const element of elements) {

		const date = element.dataset.date;
		let formats = element.dataset.formats;

		if (!date || !formats)
			return;
		
		formats = formats.split(',');
		const format = formats.map(format => `<div class="countdown-time"><span></span>${format}</div>`).join('');
		element.insertAdjacentHTML("beforeend", format);
	
		const countDownDate = new Date(date).getTime();
		
		const timer = () => {
			let now = new Date().getTime();
			let dateDiff = countDownDate - now;
	
			let time = {
				days: String(Math.floor(dateDiff / (1000 * 60 * 60 * 24))).padStart(2, '0'),
				hours: String(Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
				minutes: String(Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
				seconds: String(Math.floor((dateDiff % (1000 * 60)) / 1000)).padStart(2, '0')
			}

			time = Object.values(time);

			for (let i = 0; i < formats.length; i++) {
				element.getElementsByTagName("div")[i].getElementsByTagName("span")[0].textContent = time[i];
			}
	
			if (dateDiff < 0)
				clearInterval(timerInterval);
		}
	
		timer();
	
		const timerInterval = setInterval(timer, 1000);
	}

	
}
document.getElementsByClassName("js-countdown") && countDown(document.getElementsByClassName("js-countdown"));

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

document.addEventListener('DOMContentLoaded', () => {
    // Función para actualizar el tabindex de los elementos en el menú
    function updateMenuTabIndex() {
        const menu = document.querySelector('.overlay');
        const isMenuVisible = menu && menu.classList.contains('open');
        const elements = document.querySelectorAll('.privary-navigation__item a, .address a, .social-media a');

        elements.forEach(element => {
            element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
        });
    }

    updateMenuTabIndex();
    
    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.overlay');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }

    const menuBtn = document.getElementById('menu-btn');
    if (menuBtn) {
        menuBtn.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                menuBtn.click();
            }
        });
    }
});

